import React, { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { ProductieStatusAchizitie } from "./ProductieStatusAchizitie";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const today = iso(new Date());
const yearStart = `${new Date().getFullYear()}-01-01`;
const fmt = (n) => Number(n || 0).toLocaleString("ro-RO", { maximumFractionDigits: 0 });

const CARDS = [
  { key: "total_comenzi", label: "Comenzi unice" },
  { key: "total_validari", label: "Total validari" },
  { key: "total_pret_fab_eur", label: "Total EUR (pret fabrica)" },
];

export default function ProductieCumulat() {
  const [f, setF] = useState({ date_from: yearStart, date_to: today });
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!f.date_from || !f.date_to) return;
    setLoading(true);
    setError("");
    try {
      const { data } = await api.get("/api/productie/cumulat", { params: f });
      setData(data);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || "Eroare la incarcare");
    } finally {
      setLoading(false);
    }
  }, [f]);

  useEffect(() => { load(); }, [load]);

  return (
      <div data-testid="productie-cumulat-panel" className="space-y-4">
        <p className="text-sm text-slate-500">Productie cumulata - validari executat (sursa ERP app.amel-online.ro).</p>
        <div className="rounded border border-slate-200 bg-white p-4 flex flex-wrap items-end gap-3">
          <label className="text-xs font-medium text-slate-600">De la
            <input type="date" value={f.date_from} max={f.date_to} onChange={(e) => setF({ ...f, date_from: e.target.value })}
              className="mt-1 block h-9 px-3 rounded border border-slate-300 text-sm" data-testid="productie-date-from" />
          </label>
          <label className="text-xs font-medium text-slate-600">Pana la
            <input type="date" value={f.date_to} min={f.date_from} max={today} onChange={(e) => setF({ ...f, date_to: e.target.value })}
              className="mt-1 block h-9 px-3 rounded border border-slate-300 text-sm" data-testid="productie-date-to" />
          </label>
          {loading ? <Loader2 size={16} className="animate-spin text-slate-400" data-testid="productie-loading" /> : null}
        </div>
        {error ? <div className="rounded border border-red-200 bg-red-50 p-4 text-sm text-red-700" data-testid="productie-error">{error}</div> : null}
        {data ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {CARDS.map((c) => (
              <div key={c.key} className="rounded border border-slate-200 bg-white p-5 text-center" data-testid={`productie-card-${c.key}`}>
                <div className="text-3xl font-bold text-slate-800" data-testid={`productie-value-${c.key}`}>{fmt(data[c.key])}</div>
                <div className="mt-1 text-xs text-slate-500">{c.label}</div>
              </div>
            ))}
          </div>
        ) : null}
        <ProductieStatusAchizitie />
      </div>
  );
}
